import { useCallback, useMemo, useState } from "react";
import {
  Box,
  Flex,
  Text,
  Tabs,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
} from "@chakra-ui/react";

// components
import Stake from "@components/Stake";
import Claim from "@components/Claim";
import Unstake from "@components/Unstake";
import RightSection from "@components/RightSection";
import CenterHeader from "@components/CenterHeader";
import { trackEvent } from "dapp-sdk-v2";

import usePageData from "@hooks/usePageData";

import styles from "./styles.module.scss";
import { useSelector } from "react-redux";
import useIsMobile from "@hooks/useMobile";

const XSD = () => {
  const { isSupported, isMobile } = useIsMobile();

  const { config } = useSelector((state: any) => state.wallet);
  const { gasFeesData } = useSelector((state: any) => state.stake);

  const [tabIndex, setTabIndex] = useState(0);
  const {
    page: { data },
  } = usePageData();

  const { tabs, sub_title, title } = data;

  const allTabs = useMemo(() => {
    return tabs.map((tab: { tab: string }) => tab?.tab || "");
  }, [tabs]);

  const logTabChange = useCallback(
    (index: number) => {
      const newActiveTab = allTabs[index];
      trackEvent(`${newActiveTab}_Tab`, {});
    },
    [allTabs]
  );

  const gasFees = useMemo(() => {
    return gasFeesData?.gasFees
      ? gasFeesData.gasFees[+config.chainId]
      : undefined;
  }, [config, gasFeesData]);

  return (
    <Box
      ml={{ base: 0, xl: 60 }}
      px={{ base: "1rem", xl: "2.5rem" }}
      mt={{ base: "1rem", xl: "2rem" }}
    >
      <Flex
        flexDirection={{ base: "column", xl: "row" }}
        justifyContent="space-between"
      >
        <Box
          width="100%"
          maxWidth={{ base: "100%", xl: "536px" }}
          m="0 auto"
          pb={{ base: "0", xl: "2rem" }}
        >
          <CenterHeader
            subTitle={sub_title}
            activeTab={allTabs[tabIndex]}
            title={title}
          />
          {!isSupported && isMobile ? null : (
            <Box borderRadius="8px" width="100%" mt="2.5rem">
              <Tabs
                p="0"
                isFitted={true}
                onChange={(index) => {
                  setTabIndex(index);
                  logTabChange(index);
                }}
                index={tabIndex}
              >
                <TabList>
                  {allTabs.map((tab: any) => (
                    <Tab key={tab} p={{ base: "8px 24px", lg: "12px 24px" }}>
                      <Text>{tab}</Text>
                    </Tab>
                  ))}
                </TabList>
                <TabPanels>
                  <TabPanel px="0" pb="0" pt="0">
                    <Stake gasFees={gasFees} />
                  </TabPanel>
                  <TabPanel px="0" pb="0" pt="0">
                    <Unstake gasFees={gasFees} />
                  </TabPanel>
                  <TabPanel px="0" pb="0" pt="0">
                    <Claim
                      onUnstakeClick={() => {
                        setTabIndex(1);
                      }}
                    />
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Box>
          )}
        </Box>

        {!isSupported && isMobile ? null : (
          <Box w={{ base: "100%", xl: "312px" }}>
            <Box
              mt={{ base: "2.5rem", xl: "0" }}
              w={{ base: "100%", xl: "312px" }}
              height={{ xl: "calc(100vh - 152px)" }}
              overflow={{ xl: "auto" }}
              className={styles.rightSection}
              pb="2rem"
              position={{ xl: "fixed" }}
              right={{ xl: "40px" }}
              overflowY={{ xl: "scroll" }}
              sx={{
                "::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              <RightSection />
            </Box>
          </Box>
        )}
      </Flex>
    </Box>
  );
};

export default XSD;
